import airportMarker from './../resources/images/map/airports/airport-marker.png'
import airportMarkerRisk1 from './../resources/images/map/airports/airport-marker-risk-1.png'
import airportMarkerRisk2 from './../resources/images/map/airports/airport-marker-risk-2.png'
import airportMarkerRisk3 from './../resources/images/map/airports/airport-marker-risk-3.png'
import airportMarkerRisk4 from './../resources/images/map/airports/airport-marker-risk-4.png'
import airportMarkerRisk5 from './../resources/images/map/airports/airport-marker-risk-5.png'
import internationalSOSAlertMarker from './../resources/images/map/international-sos-alert.png'
import securityAlertLiveMarker from './../resources/images/map/security-alert-live.png'
import medicalAlertLiveMarker from './../resources/images/map/medical-alert-live.png'
import aviationAlertMarker from './../resources/images/map/aviation-alert.png'
import aviationAlertLiveMarker from './../resources/images/map/aviation-alert-live.png'
import medicalAlertMarker from './../resources/images/map/medical-alert.png'
import securityAlertMarker from './../resources/images/map/security-alert.png'
import breakingAlertMarker from './../resources/images/map/breaking-alert.png'
import breakingAlertLiveMarker from './../resources/images/map/breaking-alert-live.png'
import airportOnlyAlertMarker from './../resources/images/map/airport-only-alert.png'
import airportOnlyAlertLiveMarker from './../resources/images/map/airport-only-alert-live.png'
import tailMarker from './../resources/images/map/tail.png'
import portRisk0 from './../resources/images/map/ports/port-risk-0.png'
import portRisk1 from './../resources/images/map/ports/port-risk-1.png'
import portRisk2 from './../resources/images/map/ports/port-risk-2.png'
import portRisk3 from './../resources/images/map/ports/port-risk-3.png'
import portHighlight0 from './../resources/images/map/ports/port-highlight-0.png'
import portHighlight1 from './../resources/images/map/ports/port-highlight-1.png'
import portHighlight2 from './../resources/images/map/ports/port-highlight-2.png'
import portHighlight3 from './../resources/images/map/ports/port-highlight-3.png'

import marker84 from './../resources/images/icon/maritime/categories/84/marker.png'
import markerAlert84 from './../resources/images/icon/maritime/categories/84/markerAlert.png'
import marker85 from './../resources/images/icon/maritime/categories/85/marker.png'
import markerAlert85 from './../resources/images/icon/maritime/categories/85/markerAlert.png'
import marker86 from './../resources/images/icon/maritime/categories/86/marker.png'
import markerAlert86 from './../resources/images/icon/maritime/categories/86/markerAlert.png'
import marker87 from './../resources/images/icon/maritime/categories/87/marker.png'
import markerAlert87 from './../resources/images/icon/maritime/categories/87/markerAlert.png'
import marker88 from './../resources/images/icon/maritime/categories/88/marker.png'
import markerAlert88 from './../resources/images/icon/maritime/categories/88/markerAlert.png'
import marker89 from './../resources/images/icon/maritime/categories/89/marker.png'
import markerAlert89 from './../resources/images/icon/maritime/categories/89/markerAlert.png'
import marker90 from './../resources/images/icon/maritime/categories/90/marker.png'
import markerAlert90 from './../resources/images/icon/maritime/categories/90/markerAlert.png'
import marker91 from './../resources/images/icon/maritime/categories/91/marker.png'
import markerAlert91 from './../resources/images/icon/maritime/categories/91/markerAlert.png'
import marker92 from './../resources/images/icon/maritime/categories/92/marker.png'
import markerAlert92 from './../resources/images/icon/maritime/categories/92/markerAlert.png'
import marker93 from './../resources/images/icon/maritime/categories/93/marker.png'
import markerAlert93 from './../resources/images/icon/maritime/categories/93/markerAlert.png'
import marker94 from './../resources/images/icon/maritime/categories/94/marker.png'
import markerAlert94 from './../resources/images/icon/maritime/categories/94/markerAlert.png'
import marker95 from './../resources/images/icon/maritime/categories/95/marker.png'
import markerAlert95 from './../resources/images/icon/maritime/categories/95/markerAlert.png'
import marker96 from './../resources/images/icon/maritime/categories/96/marker.png'
import markerAlert96 from './../resources/images/icon/maritime/categories/96/markerAlert.png'
import marker97 from './../resources/images/icon/maritime/categories/97/marker.png'
import markerAlert97 from './../resources/images/icon/maritime/categories/97/markerAlert.png'
import marker98 from './../resources/images/icon/maritime/categories/98/marker.png'
import markerAlert98 from './../resources/images/icon/maritime/categories/98/markerAlert.png'
import marker108 from './../resources/images/icon/maritime/categories/108/marker.png'
import markerAlert108 from './../resources/images/icon/maritime/categories/108/markerAlert.png'
import marker109 from './../resources/images/icon/maritime/categories/109/marker.png'
import markerAlert109 from './../resources/images/icon/maritime/categories/109/markerAlert.png'
import marker110 from './../resources/images/icon/maritime/categories/110/marker.png'
import markerAlert110 from './../resources/images/icon/maritime/categories/110/markerAlert.png'
import marker113 from './../resources/images/icon/maritime/categories/113/marker.png'
import markerAlert113 from './../resources/images/icon/maritime/categories/113/markerAlert.png'
import marker115 from './../resources/images/icon/maritime/categories/115/marker.png'
import markerAlert115 from './../resources/images/icon/maritime/categories/115/markerAlert.png'
import marker594 from './../resources/images/icon/maritime/categories/594/marker.png'
import markerAlert594 from './../resources/images/icon/maritime/categories/594/markerAlert.png'
import marker595 from './../resources/images/icon/maritime/categories/595/marker.png'
import markerAlert595 from './../resources/images/icon/maritime/categories/595/markerAlert.png'
import marker596 from './../resources/images/icon/maritime/categories/596/marker.png'
import markerAlert596 from './../resources/images/icon/maritime/categories/596/markerAlert.png'


import alertClusterBreaking from './../resources/images/map/alerts/alert-cluster-breaking.png'
import alertClusterBreakingLive from './../resources/images/map/alerts/alert-cluster-breaking-live.png'
import alertCluster from './../resources/images/map/alerts/alert-cluster.png'
import alertClusterLive from './../resources/images/map/alerts/alert-cluster-live.png'


export const maritimeMarketList = [
    { id: 84, image: marker84, alertImage: markerAlert84 },
    { id: 85, image: marker85, alertImage: markerAlert85 },
    { id: 86, image: marker86, alertImage: markerAlert86 },
    { id: 87, image: marker87, alertImage: markerAlert87 },
    { id: 88, image: marker88, alertImage: markerAlert88 },
    { id: 89, image: marker89, alertImage: markerAlert89 },
    { id: 90, image: marker90, alertImage: markerAlert90 },
    { id: 91, image: marker91, alertImage: markerAlert91 },
    { id: 92, image: marker92, alertImage: markerAlert92 },
    { id: 93, image: marker93, alertImage: markerAlert93 },
    { id: 94, image: marker94, alertImage: markerAlert94 },
    { id: 95, image: marker95, alertImage: markerAlert95 },
    { id: 96, image: marker96, alertImage: markerAlert96 },
    { id: 97, image: marker97, alertImage: markerAlert97 },
    { id: 98, image: marker98, alertImage: markerAlert98 },
    { id: 108, image: marker108, alertImage: markerAlert108 },
    { id: 109, image: marker109, alertImage: markerAlert109 },
    { id: 110, image: marker110, alertImage: markerAlert110 },
    { id: 113, image: marker113, alertImage: markerAlert113 },
    { id: 115, image: marker115, alertImage: markerAlert115 },
    { id: 594, image: marker594, alertImage: markerAlert594 },
    { id: 595, image: marker595, alertImage: markerAlert595 },
    { id: 596, image: marker596, alertImage: markerAlert596 }
]
export const addMapImages = (map) => {
    const addImage = (error, image, imageName) => {
        if (error) throw error

        map.addImage(imageName, image)
    }

    map.loadImage(internationalSOSAlertMarker, (error, image) => addImage(error, image, 'international-sos-alert'))
    map.loadImage(securityAlertLiveMarker, (error, image) => addImage(error, image, 'security-alert-live'))
    map.loadImage(medicalAlertLiveMarker, (error, image) => addImage(error, image, 'security-medical-live'))
    map.loadImage(aviationAlertMarker, (error, image) => addImage(error, image, 'aviation-alert'))
    map.loadImage(aviationAlertLiveMarker, (error, image) => addImage(error, image, 'aviation-alert-live'))
    map.loadImage(medicalAlertMarker, (error, image) => addImage(error, image, 'medical-alert'))
    map.loadImage(securityAlertMarker, (error, image) => addImage(error, image, 'security-alert'))
    map.loadImage(breakingAlertMarker, (error, image) => addImage(error, image, 'breaking-alert'))
    map.loadImage(breakingAlertLiveMarker, (error, image) => addImage(error, image, 'breaking-alert-live'))
    map.loadImage(airportOnlyAlertMarker, (error, image) => addImage(error, image, 'airport-only-alert'))
    map.loadImage(airportOnlyAlertLiveMarker, (error, image) => addImage(error, image, 'airport-only-alert-live'))
    map.loadImage(tailMarker, (error, image) => addImage(error, image, 'tail-marker'))
    map.loadImage(airportMarker, (error, image) => addImage(error, image, 'airport-marker'))
    map.loadImage(airportMarkerRisk1, (error, image) => addImage(error, image, 'airport-marker-1'))
    map.loadImage(airportMarkerRisk2, (error, image) => addImage(error, image, 'airport-marker-2'))
    map.loadImage(airportMarkerRisk3, (error, image) => addImage(error, image, 'airport-marker-3'))
    map.loadImage(airportMarkerRisk4, (error, image) => addImage(error, image, 'airport-marker-4'))
    map.loadImage(airportMarkerRisk5, (error, image) => addImage(error, image, 'airport-marker-5'))
    map.loadImage(portRisk0, (error, image) => addImage(error, image, 'port-risk-0'))
    map.loadImage(portRisk1, (error, image) => addImage(error, image, 'port-risk-1'))
    map.loadImage(portRisk2, (error, image) => addImage(error, image, 'port-risk-2'))
    map.loadImage(portRisk3, (error, image) => addImage(error, image, 'port-risk-3'))
    map.loadImage(alertClusterBreaking, (error, image) => addImage(error, image, 'alert-cluster-breaking'))
    map.loadImage(alertClusterBreakingLive, (error, image) => addImage(error, image, 'alert-cluster-breaking-live'))
    map.loadImage(alertCluster, (error, image) => addImage(error, image, 'alert-cluster'))
    map.loadImage(alertClusterLive, (error, image) => addImage(error, image, 'alert-cluster-live'))
    map.loadImage(portHighlight0, (error, image) => addImage(error, image, 'port-highlight-0'))
    map.loadImage(portHighlight1, (error, image) => addImage(error, image, 'port-highlight-1'))
    map.loadImage(portHighlight2, (error, image) => addImage(error, image, 'port-highlight-2'))
    map.loadImage(portHighlight3, (error, image) => addImage(error, image, 'port-highlight-3'))


    maritimeMarketList.forEach(itmes => {
        map.loadImage(itmes.image, (error, image) => {
            addImage(error, image, `maritime-marker-${itmes.id}`)
        })
        map.loadImage(itmes.alertImage, (error, image) => {
            addImage(error, image, `maritime-alertMarker-${itmes.id}`)
        })
    })

    // THIS IS TEMPOARARY DISABLED, WE STILL WANT A PULSATING ALERT ICON, BUT IT'S IN PROGRESS
    const size = 130

    // This implements `StyleImageInterface`
    // to draw a pulsing dot icon on the map.
    const pulsingDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),

        // When the layer is added to the map,
        // get the rendering context for the map canvas.
        onAdd: function () {
            const canvas = document.createElement('canvas')
            canvas.width = this.width
            canvas.height = this.height
            this.context = canvas.getContext('2d')
        },

        // Call once before every frame where the icon will be used.
        render: function () {
            const duration = 1500
            const t = (performance.now() % duration) / duration

            const radius = (size / 2) * 0.3
            const outerRadius = (size / 2) * 0.7 * t + radius
            const context = this.context

            // Draw the outer circle.
            context.clearRect(0, 0, this.width, this.height)
            context.beginPath()
            context.arc(
                this.width / 2,
                this.height / 2,
                outerRadius,
                0,
                Math.PI * 2
            )
            context.fillStyle = `rgba(255, 255, 255, ${1 - t})`
            context.fill()

            // Draw the inner circle.
            context.beginPath()
            context.arc(
                this.width / 2,
                this.height / 2,
                radius,
                0,
                Math.PI * 2
            )
            context.fillStyle = 'rgba(255, 100, 100, 0)'
            context.strokeStyle = 'transparent'
            context.lineWidth = 2 + 4 * (1 - t)
            context.fill()
            context.stroke()

            // Update this image's data with data from the canvas.
            this.data = context.getImageData(
                0,
                0,
                this.width,
                this.height
            ).data

            // Continuously repaint the map, resulting
            // in the smooth animation of the dot.
            map.triggerRepaint()

            // Return `true` to let the map know that the image was updated.
            return true
        }
    }

    map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 })
}